import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app/app.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { currencies }from 'src/app/models/currencies'
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { AdminService } from 'src/app/services/admin/admin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerComponent } from '.././../../layout/spinner/spinner.component'
import { ErrorComponent } from 'src/app/components/layout/error/error.component';
import { AppLanguageComponent } from '../app-language/app-language.component';
import { LanguageSelectorComponent } from 'src/app/components/layout/language-selector/language-selector.component';
import { CommonModule } from '@angular/common';
import { AppLogoComponent } from '../app-logo/app-logo.component';

@Component({
  selector: 'app-app-info',
  standalone: true,
  imports: [
    SpinnerComponent,
    ErrorComponent,
    TranslateModule,
    AppLanguageComponent,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    LanguageSelectorComponent,
    AppLogoComponent
  ],
  templateUrl: './app-info.component.html',
  styleUrls: ['./app-info.component.css']
})
export class AppInfoComponent {

  // faXmark = faXmark
  @Input() fromSetup = false
  @Output() finishApp = new EventEmitter<void>();  // <-- Add this line
  socialMediaTypes = ['Facebook', 'Twitter', 'Instagram', 'LinkedIn', 'YouTube', 'TikTok'];

  currencies = currencies
  id = 0;
  load = false;
  loadBtn = false
  error = false;
  data: any;
  logo: any;

  form!: FormGroup;
  availableLanguages: any[] = [];
  selectedLanguage = '';
  systemLang = ''
  userId = 0

  showLanguage = false

  imageSrc: string | ArrayBuffer | null = null;
  dataInfo: any;

  faXmark = ''

  // mobiluris kjomponentisatvis
  phonesData:  any
  loadCheck = false
  constructor(
    private activatedRoute: ActivatedRoute,
    private appService: AppService,
    private languagesService: LanguagesService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private Router: Router,
    private translateService: TranslateService,
    private adminService: AdminService,
    private modalService: NgbModal

  ) {
    this.activatedRoute.params.subscribe(params => {
      if (params['id']) {
        this.id = params['id'];
      }
    });

    this.loadCheck = true   
    this.appService.checkAppOneAuth(this.id).subscribe(
      (res: any) => {
        this.loadCheck = false   
        
        console.log('app: ', res.data)
        
      },
      (error: any) => {
        this.loadCheck = false  
          Router.navigate(['/'])
      }
    )


    this.get()
    this.getLang();
    this.initializeForm();

    this.addLanguageField(this.selectedLanguage); // დაასხით შერჩეული ენა
    
    this.languagesService.productCategoryLanguage$.subscribe(lang => {
      this.selectedLanguage = lang
    });

    this.languagesService.selectedLanguage$.subscribe(lang => {
      this.systemLang = lang.code
    })

  }


  showLang(boolean: boolean){
    this.showLanguage = boolean
  }




  get() {
    this.load = true
    this.appService.getInfo(this.id.toString(), this.adminService.user.id.toString()).subscribe(
      (res: any) => {
        this.load = false
        this.phonesData = res.phones
        console.log('info: ',res)
        // console.log('logo: ', res.logos)
        this.logo = res.logo
        // if (res && res?.about && Array.isArray(res?.about) && res?.about.length > 0) {

        //   // this.logo = res.logos;
         
        //   this.dataInfo = res.about;
        //   // console.log(this.dataInfo);
        //   this.populateForm(this.dataInfo);
        // } else {
        //   console.error('Response does not contain titles');
        // }

        if(res.color){
          this.form.get('color').setValue(res.color);
        }

        if (res.currency) {
          // თუ currency მოდის როგორც JSON სტრიქონი, გამოიყენეთ JSON.parse
          const parsedCurrency = res.currency;
  
          // მოძებნეთ ვალუტის ობიექტი `currencies` მასივში კოდის მიხედვით
          const selectedCurrency = this.currencies.find(currency => currency.code === parsedCurrency.code);
          
          if (selectedCurrency) {
            // დააყენეთ ეს ვალუტა ფორმის `currency` ველში
            this.form.get('currency')?.setValue(selectedCurrency);
          }
        }

        if (res.phones) {
          this.populatePhones(res.phones);
        }

        if (res.socials) {
          this.populateSocials(res.socials);
        }
      },
      (error: any) => {
        this.load = false
        console.log(error);
      }
    );
  }

  initializeForm() {
    const defaultCurrency = currencies.find(currency => currency.code === 'USD') || null;

    this.form = this.fb.group({
      titles: this.fb.array([]),
      phones: this.fb.array([]),
      socials: this.fb.array([]),
      color: ['#000000', Validators.required],
      currency: [defaultCurrency, Validators.required],
      app_id: [this.id],
      user_id: [this.userId],
      image: [null]
    });
  }

  getLang() {
    this.load = true;
    this.languagesService.getActiveLanguages(this.id).subscribe(
      (res: any) => {
        this.load = false;
        this.error = false;
        this.availableLanguages = Object.keys(res).map(key => res[key]);
      },
      (error: any) => {
        this.error = true;
        this.load = false;
      }
    );
  }

  selLang(newValue: any) {
    this.selectedLanguage = newValue.target.value;
    this.addLanguageField();
    this.populateForm(this.dataInfo); // ხელახლა ჩატვირთეთ ფორმის მონაცემები შერჩეული ენის მიხედვით
  }

  get titles(): FormArray {
    return this.form.get('titles') as FormArray;
  }

  get phones(): FormArray {
    return this.form.get('phones') as FormArray;
  }

  get socials(): FormArray {
    return this.form.get('socials') as FormArray;
  }

  addLanguageField(language = this.selectedLanguage, about = '', address = ''): void {
    const existingFieldIndex = this.titles.controls.findIndex(control => control.get('language')?.value === language);
    if (existingFieldIndex === -1) {
      this.titles.push(this.fb.group({
        language: [language, Validators.required],
        about: [about],
        address: [address],
      }));
    }
  }

  addPhone(phone = ''): void {
    this.phones.push(this.createPhoneField(phone));
  }

  createPhoneField(phone: string = ''): FormGroup {
    return this.fb.group({
      phone: [phone, Validators.required]
    });
  }

  removePhone(index: number): void {
    this.phones.removeAt(index);
  }

  addSocial(type = '', link = ''): void {
    this.socials.push(this.createSocialField(type, link));
  }

  createSocialField(type: string = '', link: string = ''): FormGroup {
    return this.fb.group({
      type: [type, Validators.required],
      link: [link, Validators.required]
    });
  }

  removeSocial(index: number): void {
    this.socials.removeAt(index);
  }

  populateForm(data: any) {
    console.log(data)
    
    const existingFieldIndex = this.titles.controls.findIndex(control => control.get('language')?.value === this.selectedLanguage);
  
    if (existingFieldIndex !== -1) {
      // თუ შერჩეული ენა უკვე არსებობს, განაახლეთ ინფორმაცია
      const selectedLangData = data.find((item: any) => item.language === this.selectedLanguage);
      if (selectedLangData) {
        this.titles.at(existingFieldIndex).patchValue({
          about: selectedLangData.about,
          address: selectedLangData.address
        });
      }
    } else {
      // თუ არ მოიძებნა, დაამატეთ ახალი ველი
      const selectedLangData = data.find((item: any) => item.language === this.selectedLanguage);
      if (selectedLangData) {
        this.addLanguageField(selectedLangData.language, selectedLangData.about, selectedLangData.address);
      } else {
        this.addLanguageField(this.selectedLanguage);
      }
    }
  }

  populatePhones(phones: any) {
    phones.forEach((phone: any) => {
          const existingIndex = this.phones.controls.findIndex(control => control.value.phone === phone.phone);
          if (existingIndex === -1) {
              this.addPhone(phone.phone);
          }
      });
  }

  populateSocials(socials: any) {
    socials.forEach((social: any) => {
        const existingIndex = this.socials.controls.findIndex(control => control.value.link === social.link);
        if (existingIndex === -1) {
            this.addSocial(social.type, social.link);
        }
    });
  }

  // გამოიყენება ვალუტების შედარებისთვის
  compareCurrencies(currency1: any, currency2: any): boolean {
    return currency1 && currency2 ? currency1.code === currency2.code : currency1 === currency2;
  }

  onCurrencyChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const selectedCurrency = this.currencies.find(currency => currency.code === target.value);
    if (selectedCurrency) {
      this.form.get('currency')?.setValue(selectedCurrency);  // ვალუტის ობიექტის შენახვა
    }
  }

  skip(){
    this.Router.navigate(['/'])
  }

  update() {
    // console.log(this.form.value);
    this.loadBtn = true;
    this.form.get('user_id').setValue(this.adminService.user.id)
    this.form.get('image').setValue(this.logo)
    console.log(this.form.value)
    
    this.appService.updateAbout(this.form.value).subscribe(
      (res: any) => {
        this.loadBtn = false;
        this.toastrService.success(this.translateService.instant("SUCCESS_MESSAGE"));
        if(this.fromSetup){
          this.skip()
        }
      },
      (error: any) => {
        this.loadBtn = false;
        this.toastrService.error(this.translateService.instant("ERROR_MESSAGE"));
        // console.log(error);
      }
    );
  }
}